let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1Eeq1")).then(() => parcelRequire('kNZGg'));